/**
 * 弹窗状态管理 Hook
 */
import { useState } from 'react';

export const useModalState = () => {
  const [linkFaceLibModalVisible, setLinkFaceLibModalVisible] = useState(false);
  const [reviewModalVisible, setReviewModalVisible] = useState(false);
  const [reviewModalMode, setReviewModalMode] = useState<'view' | 'edit'>('edit');
  const [currentRecord, setCurrentRecord] = useState<any>(null);
  const [similarDriversModalVisible, setSimilarDriversModalVisible] = useState(false);
  const [similarDrivers, setSimilarDrivers] = useState<any[]>([]);
  const [similarDriversCurrentRecord, setSimilarDriversCurrentRecord] = useState<any>(null);

  // 打开关联人脸库弹窗
  const openLinkFaceLibModal = (record: any) => {
    setCurrentRecord(record);
    setLinkFaceLibModalVisible(true);
  };

  // 关闭关联人脸库弹窗
  const closeLinkFaceLibModal = () => {
    setLinkFaceLibModalVisible(false);
    setCurrentRecord(null);
  };

  // 打开审核弹窗（编辑模式）
  const openReviewModal = (record: any) => {
    setCurrentRecord(record);
    setReviewModalMode('edit');
    setReviewModalVisible(true);
  };

  // 打开审核弹窗（查看模式）
  const openReviewViewModal = (record: any) => {
    setCurrentRecord(record);
    setReviewModalMode('view');
    setReviewModalVisible(true);
  };

  // 关闭审核弹窗
  const closeReviewModal = () => {
    setReviewModalVisible(false);
    setCurrentRecord(null);
  };

  // 打开名称近似司机弹窗
  const openSimilarDriversModal = (drivers: any[], currentRecord: any) => {
    setSimilarDrivers(drivers);
    setSimilarDriversCurrentRecord(currentRecord);
    setSimilarDriversModalVisible(true);
  };

  // 关闭名称近似司机弹窗
  const closeSimilarDriversModal = () => {
    setSimilarDriversModalVisible(false);
    setSimilarDrivers([]);
    setSimilarDriversCurrentRecord(null);
  };

  return {
    linkFaceLibModalVisible,
    reviewModalVisible,
    reviewModalMode,
    currentRecord,
    similarDriversModalVisible,
    similarDrivers,
    similarDriversCurrentRecord,
    openLinkFaceLibModal,
    closeLinkFaceLibModal,
    openReviewModal,
    openReviewViewModal,
    closeReviewModal,
    openSimilarDriversModal,
    closeSimilarDriversModal,
  };
};
